import React from 'react';
import { SplitChipProps } from './SplitChip.interface';

const SplitChip = ({ value }: SplitChipProps): JSX.Element => {
    return <p>{value} u.</p>;
};

export default SplitChip;
